<ng-container *ngIf="hasFilters$ | async">
  <app-mobile-filter-bar-cont
    [isSticky]="isSticky">
    <ng-container allBtn="allBtn">
      <ng-content select="[allFiltersTag]"></ng-content>
    </ng-container>
    <ng-container selectedSlide="selectedSlide">
      <app-selected-package-filters
        [provider]="provider"
        [isMobile]="true"
        [inFilterBar]="true"
        [codePlaces]="codePlacesByPackageSearch"
        (sharedShouldShowFilters)="sharedShouldShowFiltersByPackage($event)"
        (sharedSelectedHotelFilters)="sharedSelectedHotelFilters($event)"
        (sharedSelectedAirFilters)="sharedSelectedAirFilters($event)"
        (checkboxEvent)="checkboxHotelAction($event)">
      </app-selected-package-filters>
    </ng-container>
    <ng-container filterSlide="filterSlide">
      <ng-container [ngSwitch]="provider">
        <ng-container *ngSwitchCase="packageFilterProvider.HOTEL">
          <ng-container *ngTemplateOutlet="hotelSlide"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="airSlide"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!isHotelView" barWidgets="barWidgets">
      <app-air-filter-bar-airlines
        [filters]="airFilterVm$ | async"
        [pickedCheckboxes]="pickedCheckboxes"
        (airlineFilterEvent)="airlineFilterApply($event)">
      </app-air-filter-bar-airlines>
    </ng-container>
    <ng-container moreBtn="moreBtn">
      <ng-content select="[moreFiltersTag]"></ng-content>
    </ng-container>
  </app-mobile-filter-bar-cont>
</ng-container>

<ng-template #hotelSlide>
  <app-hotel-filter-bar-slide
    [barFilters]="barHotelFilters$ | async"
    [showExclusiveOfferFilter]="showExclusiveOfferFilter$ | async"
    [tagTypeIsRappicard]="tagTypeIsRappicard$ | async"
    [tagTypeIsPrime]="tagTypeIsPrime$ | async"
    [pickedTotalDiscountPercentage]="pickedTotalDiscountPercentage"
    [pickedMemberRatesOnly]="pickedMemberRatesOnly"
    [selectedStarItems]="selectedStarItems"
    [pickedCheckboxes]="pickedCheckboxes"
    [pickedStars]="pickedStars"
    (exclusiveOfferFilterEvent)="exclusiveOfferFilterAction()"
    (checkboxEvent)="checkboxHotelAction($event)"
    (radioEvent)="radioHotelAction($event)">
  </app-hotel-filter-bar-slide>
</ng-template>

<ng-template #airSlide>
  <app-air-filter-bar-slide
    [barFilters]="barAirFilters$ | async"
    [allFilter]="airFilterVm$ | async"
    [orderCriteria]="airOrderCriteria$ | async"
    [orderCriteriaSectorNumber]="airOrderCriteriaSectorNumber$ | async"
    [orderDesc]="airOrderDesc$ | async"
    [codePlaces]="codePlacesByPackageSearch"
    [pickedCheckboxes]="pickedCheckboxes"
    [pickedAirportCheckboxes]="pickedAirportCheckboxes"
    [pickedRanges]="pickedRanges"
    [sortFilterHasBeenChangedByPackage]="sortFilterHasBeenChangedByPackage$ | async"
    [isAirByPackage]="true"
    (sortEvent)="sortAirAction($event)"
    (checkboxEvent)="checkboxAirAction($event)"
    (rangeEvent)="rangeAirAction($event)">
  </app-air-filter-bar-slide>
</ng-template>